'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("whatwg-fetch");

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Login = /*#__PURE__*/function (_React$Component) {
  _inherits(Login, _React$Component);

  function Login(props) {
    var _this;

    _classCallCheck(this, Login);

    _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
    _this.state = {
      username: '',
      password: '',
      error: false,
      success: false
    };
    _this.submit = _this.submit.bind(_assertThisInitialized(_this));
    _this.updateUsername = _this.updateUsername.bind(_assertThisInitialized(_this));
    _this.updatePassword = _this.updatePassword.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Login, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "compLogin grid-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell medium-10 large-9 xlarge-8"
      }, /*#__PURE__*/_react.default.createElement("h1", null, t('Login')), this.topMessage(), /*#__PURE__*/_react.default.createElement("form", {
        method: "post",
        onSubmit: this.submit,
        className: "grid-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell comp-form-field"
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "input"
      }, t('username'), /*#__PURE__*/_react.default.createElement("span", {
        className: "input__wrapper"
      }, /*#__PURE__*/_react.default.createElement("input", {
        autoFocus: true,
        type: "text",
        name: "username",
        placeholder: t('username'),
        value: this.state.username,
        onChange: this.updateUsername
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell comp-form-field"
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "input"
      }, t('password'), /*#__PURE__*/_react.default.createElement("span", {
        className: "input__wrapper"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "password",
        name: "password",
        placeholder: t('password'),
        value: this.state.password,
        onChange: this.updatePassword
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn"
      }, t('Login'))))));
    }
  }, {
    key: "submit",
    value: function submit(event) {
      var _this2 = this;

      event.preventDefault();
      var credentials = {
        username: this.state.username,
        password: this.state.password
      };

      if (!credentials.username || !credentials.password) {
        this.setState({
          error: 'Missing Credentials'
        });
        return;
      }

      fetch('/login', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this2.props.history.push(response.redirect);
      }).catch(function (err) {
        _this2.setState({
          error: err.message
        });
      });
    }
  }, {
    key: "updateUsername",
    value: function updateUsername(event) {
      this.setState({
        username: event.target.value
      });
    }
  }, {
    key: "updatePassword",
    value: function updatePassword(event) {
      this.setState({
        password: event.target.value
      });
    }
  }, {
    key: "topMessage",
    value: function topMessage() {
      var t = this.props.t;
      if (this.state.error) return /*#__PURE__*/_react.default.createElement("div", {
        "data-abide-error": true,
        role: "alert",
        className: "alert callout"
      }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("i", {
        className: "fi-warning"
      }), t(this.state.error)));
    }
  }]);

  return Login;
}(_react.default.Component);

Login.propTypes = {
  t: _propTypes.default.func,
  i18n: _propTypes.default.shape({
    changeLanguage: _propTypes.default.func
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func
  })
};

var _default = (0, _translate.default)(Login);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/login/index.js
// module id = 742
// module chunks = 0